import { buildQuery } from "../lib/network";
import { coreService } from "../services/coreService";

export type Spotlights = Awaited<ReturnType<typeof coreService.releaseNotesList>>["data"]["spotlights"];
export const fetchReleaseNotes = (headers: any) => () =>
  buildQuery(coreService.releaseNotesList({ headers }), (response) => response.data);
